/* eslint-disable */

function subscribeErrorDataLayer (errorText) {
    if (errorText.length > 0) {
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'footer_navigation',
            'eventAction': 'newsletter_failed',
            'eventLabel': 'newsletter failed',
            'failedReason': errorText,
            'country': window.GlobalAttributes.COUNTRY,
            'language': window.GlobalAttributes.LANGUAGE,
            'screenName': 'Footer navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    }
}

function subscribeSuccessDataLayer () {
    dataLayer.push({
        'event': 'custom_event',
        'eventCategory': 'footer_navigation',
        'eventAction': 'newsletter_signup',
        'eventLabel': 'newsletter_signup success',
        'country': window.GlobalAttributes.COUNTRY,
        'language': window.GlobalAttributes.LANGUAGE,
        'screenName': 'Footer navigation',
        'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
        'userId': user.user_id != '' ? user.user_id : ''
    });
}

function init() {

    // Get the popup
    const $popup = $("#subscribePopup");

    // Get the button that opens the popup
    const $openPopup = $("#subscribeBtn");

    // Get the <span> element that closes the popup
    const $closePopup = $("#subscribeClosePopup");

    // When the user clicks the button, open the popup
    $openPopup.on("click", function() {
        $popup.css("display", "flex");
    });

    // When the user clicks on <span> (x), close the popup
    $closePopup.on("click", function() {
        $popup.hide();
        $('.subscribe-title').show();
        $('.footer__subscribe').show();
        $('.subscribe__success').addClass('hidden');
        $('form.footer__subscribe__form')[0].reset();
    });

    // When the user clicks anywhere outside of the popup, close it
    $(window).on("click", function(event) {
        if ($(event.target).is($popup)) {
            $popup.hide();
            $('.subscribe-title').show();
            $('.footer__subscribe').show();
            $('.subscribe__success').addClass('hidden');
            $('form.footer__subscribe__form')[0].reset();
        }
    });

    $(document).on('submit','form.footer__subscribe__form', function (e) {
        e.preventDefault();
        $('#form-subscribe-error').text('');
        $('span#dwfrm_moengage_emailsignup_email-error').text('');
        var form = $(this);
        var url = form.attr('action');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                //eslint-disable-next-line
                $('.loader').hide();
                if (!data.success) {
                    $('#form-subscribe-error').text(data.msg);
                    subscribeErrorDataLayer(data.msg);
                }
                else {
                    $('.subscribe-title').hide();
                    $('.footer__subscribe').hide();
                    $('.subscribe__success').removeClass('hidden');
                    subscribeSuccessDataLayer();
                }
            },
            error: function (data) {}});
        return false;
    });
    
    let inputTimeout;
    $(document).on('blur', 'input#dwfrm_moengage_emailsignup_email', function () {
        clearTimeout(inputTimeout);
        inputTimeout = setTimeout(() => {
            if($('span#dwfrm_moengage_emailsignup_email-error').text().trim().length > 0) {
                subscribeErrorDataLayer($('span#dwfrm_moengage_emailsignup_email-error').text().trim());
            }
        }, 1000);
    });
}
module.exports = {
    init: init
};


// WEBPACK FOOTER //
// ./cartridges/app_boggi_core/cartridge/js/sections/footer/subscribe.js